import React from 'react'

export default function Logo({ logoLink }) {
    return (
        <img className="logo" src={logoLink} alt=""/>
    )
}
